module.exports = __webpack_public_path__ + "img/viewProject.7df409d1.svg";